import {
    getEnumItemByValue,
    PLATFORMA_TYPES,
    OUTAGE_NOTIFICATION_CONDITION_TYPE,
    OUTAGE_NOTIFICATION_FILTER_TYPE,
    EnumDescription,
    PLATFORMA_TYPES_ENUM,
    OUTAGE_NOTIFICATION_FILTER_TYPE_ENUM,
    OUTAGE_NOTIFICATION_CONDITION_TYPE_ENUM,
} from '../common/enums';

export default class OutageNotification {
    id: number;
    name: string;
    text: string;
    platform: number;
    platformEnumDescription: EnumDescription | undefined;
    notificationTo?: Date;
    notificationFrom?: Date;
    outageTo?: Date;
    outageFrom?: Date;
    order: number;
    filter: number;
    filterEnumDescription: EnumDescription | undefined;
    condition?: number;
    conditionEnumDescription?: EnumDescription | undefined;
    version?: string;
    groupName?: string;
    isUpdateForced: boolean;

    constructor(properties: Partial<OutageNotification> & Pick<OutageNotification, 'platform' | 'filter' | 'condition'>) {
        this.id = -1;
        this.name = '';
        this.text = '';
        this.platform = PLATFORMA_TYPES_ENUM.ALL;
        this.filter = OUTAGE_NOTIFICATION_FILTER_TYPE_ENUM.NONE;
        this.order = 0;
        this.version = undefined;
        this.groupName = undefined;
        this.isUpdateForced = false;

        Object.assign(this, properties);

        this.platformEnumDescription = getEnumItemByValue(properties.platform, PLATFORMA_TYPES);
        this.filterEnumDescription = getEnumItemByValue(properties.filter, OUTAGE_NOTIFICATION_FILTER_TYPE);
        this.conditionEnumDescription = properties.condition
            ? getEnumItemByValue(properties.condition, OUTAGE_NOTIFICATION_CONDITION_TYPE)
            : undefined;

        this.notificationTo = properties.notificationTo ? new Date(properties.notificationTo) : properties.notificationTo;
        this.notificationFrom = properties.notificationFrom ? new Date(properties.notificationFrom) : properties.notificationFrom;

        this.outageTo = properties.outageTo ? new Date(properties.outageTo) : properties.outageTo;
        this.outageFrom = properties.outageFrom ? new Date(properties.outageFrom) : properties.outageFrom;
    }
}
